module.exports = __webpack_public_path__ + "img/drag-icon.9f16de5f.svg";